import { fetchComments } from 'object-comments-thread-lib/apis/CommentingApi';
import { registerQuery, useQuery } from 'data-fetching-client';
import Raven from 'raven-js';
export { createComment, updateComment, deleteComment } from 'object-comments-thread-lib/apis/CommentingApi';
export const fetchCommentsForEngagement = engagementId => {
  return fetchComments(engagementId, 'ENGAGEMENT');
};
export const CommentsForEngagementQuery = registerQuery({
  fieldName: 'commentsForEngagement',
  args: ['engagementId'],
  fetcher({
    engagementId
  }) {
    return fetchCommentsForEngagement(engagementId).then(response => response.results);
  }
});
export const useFetchCommentsForEngagement = (engagementId, {
  pollInterval
} = {}) => {
  return useQuery(CommentsForEngagementQuery, {
    variables: {
      engagementId
    },
    skip: !engagementId,
    pollInterval,
    onError: error => {
      Raven.captureException(error);
    }
  });
};